import * as Yup from 'yup'
export const phoneNumberRegex = /^\d{10}$/;
export const zipCodeRegex = /^[A-Za-z0-9]{5,6}$/;
export const EMAIL = {
  label: "Email",
  validation: {
    required: "Email is required",
    valid: "Please enter a valid email address.",
    invalidCaps: 'Email is invalid, please type in lowercase.',
  },
};
export const ZIP_CODE = {
  label: "Zip Code",
  validation: {
    required: "Zip Code is required",
    valid: "Zip Code must be a valid alphanumeric string with 5 or 6 characters",
    minLength: {
      value: 5,
      message: "Zip Code must be at least 5 digits",
    },
    maxLength: {
      value: 6,
      message: "Zip Code must not exceed 6 digits",
    },
  },
  regex: zipCodeRegex
};
export const HOSPITAL_NAME = {
  label: "Hospital Name",
  validation: {
    valid: "Hospital name is required.",
    required:"Hospital name is required"
  },
};
export const SPECIALITY = {
  label: "Specialities",
  validation: {
    required: "Specialities is required",
  },
};
export const SIGNATURE = {
  label: "Signature",
  validation: {
    required: "Signature is required",
  }
};
export const CONTACT_NUMBER = {
  label: "Contact number",
  validation: {
    valid: "Please enter a valid 10-digit contact number.",
    required:"Contact number is required"
  },
};
export const Name = {
  label: "Name",
  validation: {
    valid: "Name is required",
    required:"Name is required"
  },
};
export const Role = {
  label: "Role",
  validation: {
    valid: "Role is required",
    required:"Role is required"
  },
};
export const DOB = {
  label: "Date of Birth",
  validation: {
    valid: "DOB is required",
    required:"DOB is required"
  },
};
export const LICENSE_NUMBER = {
  label: "LICENSE NUMBER",
  validation: {
    valid: "License number is required",
    required:"License number is required"
  },
};

const role = sessionStorage?.getItem("role")

export const hospitalFormSchema=Yup.object().shape({
  hospitalName: role === 'Superadmin' ? Yup.string().matches(/^[a-zA-Z\s]+$/, 'Name must contain only letters') : Yup.string().matches(/^[a-zA-Z\s]+$/, 'Name must contain only letters').required(HOSPITAL_NAME.validation.required),
  hospitalEmailId: role === 'Superadmin' ? Yup.string().email().test('no-uppercase', EMAIL.validation.invalidCaps, value => {
    return !value || value === value.toLowerCase();
  }) : Yup.string().email().required(EMAIL.validation.required).test('no-uppercase', EMAIL.validation.invalidCaps, value => {
    return !value || value === value.toLowerCase();
  }),
  contactNumber: role === 'Superadmin' ? Yup.string().matches(phoneNumberRegex, 'Contact number must be of 10 digits') : Yup.string().matches(phoneNumberRegex, 'Contact number must be of 10 digits').required(CONTACT_NUMBER.validation.valid),
  zipCode: Yup.string()
    .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
    .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
    .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
  specialitites: role === 'Superadmin' ? Yup.array() : Yup.array().required(SPECIALITY.validation.required).test('is-valid', SPECIALITY.validation.required, (value) => {
    return value && value.length > 0;
  }),
  signature: role === "hospitalsuperadmin" ? Yup.string().required(SIGNATURE.validation.required) : null,
  superAdminName:Yup.string().matches(/^[a-zA-Z\s]+$/, 'Name must contain only letters').required(Name.validation.required),
  superAdminEmail:Yup.string().required(EMAIL.validation.required).test('no-uppercase', EMAIL.validation.invalidCaps, value => {
    return !value || value === value.toLowerCase();
  }),
  superAdminContactNumber:Yup.string().matches(phoneNumberRegex, 'Contact number must be of 10 digits').required(CONTACT_NUMBER.validation.valid),
  superAdminWhatsappNumber:Yup.string().matches(phoneNumberRegex, 'Whatsapp number must be of 10 digits').required(CONTACT_NUMBER.validation.valid),
  telepathology: Yup.boolean(),
  teleradiology: Yup.boolean(),
  speechToText: Yup.boolean(),
  aiServices: Yup.boolean()
})

export const userFormSchema=Yup.object().shape({
  name:Yup.string().required(Name.validation.required),
  employeeId:Yup.string(),
  role:Yup.string().required(Role.validation.required),
  hprid:Yup.string(),
  gender:Yup.string(),
  email:Yup.string().email(EMAIL.validation.required).test('no-uppercase', EMAIL.validation.invalidCaps, value => {
    return !value || value === value.toLowerCase();
  }),
  contactNumber:Yup.string().matches(phoneNumberRegex, 'Contact number must be of 10 digits').required(CONTACT_NUMBER.validation.valid),
  dob: Yup.date().required(DOB.validation.required),
  department:Yup.string(),
  zipCode: Yup.string()
  .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
  .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
  .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
  specialitites: Yup.array().required(SPECIALITY.validation.required).test('is-valid', SPECIALITY.validation.required, (value) => {
    console.log('Validating specialties:', value);
    return value && value.length > 0;
  }),
  signature: Yup.string().required(SIGNATURE.validation.required),
  specialization:Yup.string(),
  yearsOfExperience:Yup.string(),
  whatsappNumber: Yup.string().matches(phoneNumberRegex, 'Whatsapp number must be of 10 digits'),
  licenseNumber:Yup.string().required(LICENSE_NUMBER.validation.required)
})
